import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";

const fetchVenue = async (id, venueName) => {
    const res = await axios.get(`${API_BASE_URL}/venue/${id}/${venueName}`);
    return res.data?.data?.[0] ?? {};
};

export const useVenue = (id, venueName) => {
    const { data, isLoading } = useQuery({
        queryKey: ["venue", id, venueName],
        queryFn: () => fetchVenue(id, venueName),
        enabled: !!id && !!venueName,
        staleTime: 10 * 60 * 1000,
    });

    return {
        venue: data ?? {},
        isLoading,
    };
};
